import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getModifiedApplicationStateForFiu } from './getFiuMakerList'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return { ...data, ...data.inputDto, applicationState: getModifiedApplicationStateForFiu(data.applicationState) }
}

const checkApplicationStatusReq = (applicationId: string, tokens: any, auditType: string, abortController = null) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.checkStatus),
    method: 'POST',
    cache: false,
    body: { applicationId: applicationId, ...(auditType && { processDefinitionKeyType: auditType }) },
    config: sitConfig(tokens, abortController),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { checkApplicationStatusReq }
